import BoxScannedPopup from '../components/popups/boxScannedPopup/BoxScannedPopup';
import scanViewController from './scanViewController';
import boxScannedPopupModel from "../components/popups/boxScannedPopup/BoxScannedPopup.model";
import {PopupAnimationMs} from "../utils/animationConstants";

let ResealController = function () {
	this.foundBox = (box, drug, onSuccess, optionalWitness, isOptional) => {
		scanViewController.hideMainViewDuringAnimation();
		scanViewController.hideScanner(PopupAnimationMs * 2, 'behind');
		openEmptyBoxScannedPopup(box, drug,true, onSuccess, optionalWitness, isOptional)
	};
};

let resealController = new ResealController();

export default resealController;

export const openEmptyBoxScannedPopup = (value, lastDrugScanned,reseal, onSuccess, optionalWitness, isOptional) => {
  boxScannedPopupModel.clear()
  window.popupController.show(BoxScannedPopup, {
    value,
    lastDrugScanned,
    reseal,
    onSuccess,
    optionalWitness,
    isOptional
  });
};
